import component from './component';
import systemMessage from './system/systemMessages';
import pageMessages from './page';
import registeredDevices from './device/registeredDevices';
import publicUserProfile from './user/publicUserProfile';
import userSocialProfile from './user/userSocialProfile';
import userPrivacy from './user/userPrivacy';
import customUserPrivacy from './userPrivacy/userPrivacy';
import comments from './conversation/comments';
import conversations from './conversation/conversations';
import dailySummary from './dailySummary';
import personalRecords from './personalRecords/personalRecords';
import personalRecordCandidates from './personalRecords/personalRecordCandidates';
import personalRecordTypes from './personalRecords/personalRecordTypes';
import personalRecordByActivityId from './personalRecords/personalRecordByActivityId';
import badges from './badge/badges';
import validateDailySummary from './validate/validateDailySummary';
import validateDeviceEpoch from './validate/validateDeviceEpoch';
import validateDeviceEpochSummary from './validate/validateDeviceEpochSummary';
import validateDeviceHeartRate from './validate/validateDeviceHeartRate';
import validateDeviceHeartRateSummary from './validate/validateDeviceHeartRateSummary';
import matSupportPage from './matSupportPage';
import connectionProfileStatus from './user/connectionProfileStatus';
import pendingConnections from './user/pendingConnections';
import connectionsLeaderboard from './leaderboard/connectionLeaderboard';
import modalState from './modal/modal';
import userPersonalInfo from './user/userPersonalInfo';
import userDailySteps from './user/userDailySteps';
import userStatistics from './user/userStatistics';
import favoriteActivities from './activity/favoriteActivities';
import calendarPage from './pages/calendarPage';
import trainingPlansForDate from './trainingPlan/trainingPlansForDate';
import activityTypes from './activity/activityTypes';
import activityHrTimeInZones from './activity/activityHrTimeInZones';
import activityPowerTimeInZones from './activity/activityPowerTimeInZones';
import surfaceTypes from './segment/surfaceTypes';
import segmentTypes from './segment/segmentTypes';
import activities from './activity/activities';
import goals from './goal/goals';
import courses from './course/courses';
import comCourses from './trail/trails';
import workouts from './workout/workouts';
import workoutById from './workout/workoutById';
import workoutSteps from './workout/workoutSteps';
import workoutSchedule from './workout/workoutSchedule';
import workoutsExport from './workout/workoutsExport';
import workoutsFilter from './workout/workoutsFilter';
import workoutTypes from './workout/workoutTypes';
import exerciseData from './exercises/exerciseData';
import upcomingEvents from './user/upcomingEvents';
import upcomingCalEvents from './user/upcomingCalEvents';
import profilePage from './pages/profilePage';
import monthlyReport from './reports/monthlyReport';
import stepsReports from './reports/stepsReports';
import pushesReports from './reports/pushesReports';
import activities365Report from './reports/activities365Report';
import activityList from './activity/activityList';
import activityPolyline from './activity/activityPolyline';
import activityMapDetailsReducer from './activityMapDetails/activityMapDetailsReducer';
import gear from './gear/gear';
import commentLikes from './conversation/commentLikes';
import conversationLikes from './conversation/conversationLikes';
import groupConversations from './conversation/groupConversations';
import groupConversationLikes from './conversation/groupConversationLikes';
import userPreference from './userPreference';
import preference from './preference/preference';
import activitySearch from './activity/activitySearch';
import selectedDive from './diving/divingMap';
import activitySummary from './activity/activitySummary';
import activitySummaryWeekly from './activity/activitySummaryWeekly';
import activitySummaryMonthly from './activity/activitySummaryMonthly';
import activitySummaryYearly from './activity/activitySummaryYearly';
import systemPreference from './system/systemPreferences';
import HERELocation from '../Popularity/Reducer';
import usageIndicators from './user/usageIndicators';
import segmentPage from './pages/segmentPage';
import playerGolfStats from './golf/playerGolfStats';
import driveGolfStats from './golf/driveGolfStats';
import approachGolfStats from './golf/approachGolfStats';
import chipGolfStats from './golf/chipGolfStats';
import puttGolfStats from './golf/puttGolfStats';
import golfStatsPageState from './golf/golfStatsPageState';
import golfClubs from './golf/golfClubs';
import golfClubTypes from './golf/golfClubTypes';
import segment from './segment/segment';
import groups from './group/groups';
import groupPage from './group/groupPage';
import groupPageLeaderboard from './group/groupPageLeaderboard';
import groupPageInvite from './group/groupPageInvite';
import groupPageCourse from './group/groupPageCourse';
import groupPageReportPhotoDialog from './group/groupPageReportPhotoDialog';
import segments from './segment/segments';
import badgesPage from './pages/badgesPage';
import atpPlan from './trainingPlan/adaptiveTrainingPlan';
import atpNextWorkout from './trainingPlan/adaptiveTrainingPlanNextWorkout';
import atpCalendar from './trainingPlan/adaptiveTrainingPlanCalendar';
import atpRescheduleDays from './trainingPlan/rescheduleDays';
import atpFeed from './trainingPlan/adaptiveTrainingPlanFeed';
import adaptiveTrainingPlanArticle from './trainingPlan/adaptiveTrainingPlanArticle';
import atpFeedPartialContent from './trainingPlan/adaptiveTrainingPlanPartialArticle';
import atpContentFulVideoItem from './trainingPlan/adaptiveTrainingPlanVideoItem';
import atpActivityFeedback from './trainingPlan/adaptiveTrainingPlanActivityFeedback';
import gdprFeature from './gdpr/gdprFeature';
import gdprConsentText from './gdpr/gdprConsentText';
import gdprGrantConsent from './gdpr/gdprGrantConsent';
import gdprRevokeConsent from './gdpr/gdprRevokeConsent';
import gdprDisplayLimitedFeatureAlert from './gdpr/gdprDisplayLimitedFeatureAlert';
import atpCoachInfo from './trainingPlan/adaptiveTrainingPlanCoach';
import fitnessStats from './stats/fitnessStats';
import pulseOxAcclimation from './pulseOxAcclimation/pulseOxAcclimation';
import activitiesForDailySummary from './dailySummary/activitiesForDailySummary';
import activitiesListForTimeframe from './dailySummary/activitiesListForTimeframe';
import mergedSummary from './dailySummary/mergedSummary';
import mergedSummaryCount from './dailySummary/mergedSummaryCount';
import lastSyncTimestamp from './dailySummary/lastSyncTimestamp';
import dailySleepData from './dailySummary/dailySleepData';
import autoDetectedEvents from './dailySummary/autoDetectedEvents';
import dailyStressData from './dailySummary/dailyStress';
import dailyMovement from './dailySummary/dailyMovement';
import dailyHeartRate from './dailySummary/dailyHeartRate';
import heartRateZones from './biometrics/heartRateZones';
import powerZones from './biometrics/powerZones';
import moveIQEvents from './moveIQ/moveIQ';
import deviceList from './device/deviceList';
import registeredDeviceList from './device/registeredDeviceList';
import deviceInfo from './device/deviceInfo';
import primaryTrainingDevice from './device/primaryTrainingDevice';
import deviceInfoByPartNumber from './device/deviceInfoByPartNumber';
import deviceByHealthDeviceId from './device/deviceByHealthDeviceId';
import hydration from './hydration/hydration';
import viewerUserPreferences from './viewerUserPreferences/viewerUserPreferences';
import userSettings from './userSettings/userSettings';
import userStats from './userStats/userStats';
import userSummaryAverages from './user/userSummaryAverages';
import strava from './strava/Strava';
import insightsList from './insights/insightsList';
import stepsLifetimeTotals from './totals/stepsLifetimeTotals';
import paceProCreate from './pacePro/paceProCreate';
import mfpLinkStatus from './mfp/MFPLinkStatus';
import wellnessGoals from './dailySummary/wellnessGoals';
import consolidatedStepsGoal from './dailySummary/consolidatedStepsGoal';
import consolidatedPushesGoal from './dailySummary/consolidatedPushesGoal';
import dailySteps from './dailySummary/dailySteps';
import paceProBand from './pacePro/paceProBand';
import menstrualCycleTrackingSummary from './menstrualCycleTracking/menstrualCycleTrackingSummary';
import menstrualCycle from './menstrualCycleTracking/menstrualCycleTracking';
import menstrualCycleTrackingCalendar from './menstrualCycleTracking/menstrualCycleTrackingCalendar';
import menstrualCycleTrackingReports from './menstrualCycleTracking/menstrualCycleTrackingReports';
import menstrualCycleTrackingInitialSetup from './menstrualCycleTracking/menstrualCycleTrackingInitialSetup';
import workoutExecutionMetrics from './workoutExecutionMetrics/workoutExecutionMetrics';
import userCapable from './userCapable/userCapable';
import bodyBatteryToday from './dailySummary/bodyBatteryToday';
import weightList from './weight/weightList';
import dailySummaryActions from './dailySummary/dailySummaryActions';
import dailyCalories from 'reducers/dailySummary/dailyCalories';
import mfp from 'reducers/mfp/mfp';
import dailyPulseOxData from './dailyPulseOx/dailyPulseOxData';
import dailyRespirationData from './respiration/dailyRespirationData';
import paceProAlgorithmConfig from './pacePro/paceProAlgorithm';
import pregnancyTracking from 'reducers/pregnancyTracking/pregnancyTracking';
import dayWeightList from './weight/dayWeightList';
import weightPage from './weight/weightPage';
import latestWeight from './weight/latestWeight';
import wellnessGoal from './goal/wellnessGoals';
import golfCourse from './golf/course/golfCourse';
import golfCourses from './golf/course/golfCourses';
import golfCourseStats from './golf/course/golfCourseStats';
import golfCourseLayout from './golf/course/golfCourseLayout';
import solarIntensity from './solar/solarIntensity';
import trainingStatusDaily from './trainingStatus/trainingStatusAggregatedData';
import trainingStatusReport from './trainingStatus/trainingStatusReport';
import phasedTrainingPlan from './trainingPlan/phasedTrainingPlan';
import powerGuidance from './powerGuidance/powerGuidance';
import indoorClimbDifficulty from './routeDifficulties/climbDifficulties';
import intensityMinutes from './intensityMinutes/intensityMinutes';
import activityDetails from './activityDetails/activityDetails';
import weatherStationDTO from './activityDetails/weather';
import challenge from './challenge/challenge';
import epochDataReload from './epochDataReload/epochDataReload';
import userSummaryMonthly from './user/userSummaryMonthly';
import bloodPressure from './bloodPressure/bloodPressure';
import latestBP from './bloodPressure/latestBP';
import fitnessAge from './fitnessAge/fitnessAge';
import ftp from './ftp/ftp';
import ftpRange from './ftp/ftpRange';
import typedSplits from './activityTypedSplits/typedSplits';
import benchmarkExercises from './benchmarkExercises/benchmarkExercises';
import exerciseTypes from './exerciseTypes/exerciseTypes';
import exerciseEquipments from './exerciseEquipments/exerciseEquipments';
import golfProfile from './golf/profile/golfProfile';
import timeZones from './system/timeZones';
import shareableEvent from './shareableEvent/shareableEvent';
import muscleMappingModel from './muscleMappingModel/muscleMappingModel';
import golfScorecardSummary from './golf/scorecard/golfScorecardSummary';
import exportReportReducer from './exportReport/exportReportReducer';
import healthSnapshotList from './healthSnapshot/healthSnapshotList';
import healthSnapshotDetails from './healthSnapshot/healthSnapshotDetails';
import healthSnapshotsForDailySummary from './dailySummary/healthSnapshotsForDailySummary';
import powerBenchmarks from './powerBenchmarks/powerBenchmarks';
import newsFeedActivities from './newsFeed/newsFeedActivities';
import newsFeedComments from './newsFeed/newsFeedComments';
import newsFeedLikes from './newsFeed/newsFeedLikes';
import newsFeedConnections from './newsFeed/newsFeedConnections';
import hrvStatus from './hrvStatus/hrvStatus';
import notification from './notification/notification';
import multiSportActivitySummary from './multiSportEdit/multiSportActivitySummary';
import ecgRecordingList from './ecg/ecgRecordingList';
import ecgRecordingDetails from './ecg/ecgRecordingDetails';
import ecgRecordingDailySummary from './dailySummary/ecgRecordingDailySummary';
import ecgRecordings from './dailySummary/ecgRecordings';
import eventBasedGoals from 'reducers/calendar/eventBasedGoals';
import blockUser from './blockUser/blockUser';
import floorsData from './floorsData/floorsData';
import floorsReportData from './floorsReport/floorsReport';
import totalCaloriesReports from './reports/totalCaloriesReports';
import trainingReadiness from './trainingReadiness/trainingReadiness';
import mutualConnections from './mutualConnections/mutualConnections';
import hydrationDataReports from './reports/hydrationReports';
import stressDataReports from './reports/stressReports';
import demographicSelections from './insights/demographicSelections';
import demographicCompare from './insights/demographicCompare';
import demographicComparePreferences from './insights/demographicComparePreferences';
import insightData from './insights/insightData';
import connections from './connection/connections';
import heartRateReport from './heartRateReport/heartRateReport';
import sleepDataReports from './reports/sleepReports';
import jetLagSetupTrip from './jetLag/jetLagSetupTrip';
import jetLagTrips from './jetLag/jetLagTrips';
import jetLagDailyStatus from './jetLag/jetLagDailyStatus';
import cssReports from './criticalSwimSpeed/criticalSwimSpeed';
import challengePage from './challengePage/challengePage';
import systemReducer from './system/systemReducer';
import gears from './gears/gears';
import golfClubsFlexTypes from './golf/golfClubsFlexTypes';
import bodyBattery from './bodyBattery/bodyBattery';
import inboxPage from './inboxPage/inboxPage';
import deviceBackups from './device/deviceBackups';
import sleepReport from './sleep/sleepReport';
import dailySleepEpochs from './sleep/dailySleepEpochs';
import emailNotification from './email/emailNotification';
import latestLactateThreshold from './lactateThreshold/latestLactateThresholdReducers';
import lactateThresholdRangeHR from './lactateThreshold/rangeLactateThresholdHRReducers';
import lactateThresholdRangeSpeed from './lactateThreshold/rangeLactateThresholdSpeedReducers';
import currentUserInfo from './modern/currentUserInfo';
import thirdPartyApps from './thirdPartyApps/thirdPartyApps';
import hillScoreDataReports from './reports/hillScoreReports';
import optionalFeature from './optionalFeature/optionalFeature';
import vo2MaxMetrics from './vo2MaxMetrics/vo2MaxMetrics';
import enduranceScoreDataReports from './reports/enduranceScoreReports';
import reportsToggledItems from './reports/reportsToggledItems';
import dailyPushes from './dailySummary/dailyPushes';
import createChallengePage from './createChallengePage/createChallengePageReducer';
import golfPlayerShots from './golf/shots/golfPlayerShots';
import golfHistoricalShots from './golf/shots/golfHistoricalShots';
import trainingPlanIntegration from 'reducers/trainingPlan/trainingPlanIntegration';
import fbtAdaptiveCoachingTrainingPlan from 'reducers/trainingPlan/fbtAdaptiveCoachingTrainingPlan';
import socialReducer from './social/socialReducer';
import deviceBetaSoftwareInfo from './device/deviceBetaSoftwareInfo';
import dswTrainingPlans from './DSW/dswTrainingPlans';
import golfScorecard from './golf/scorecard/golfScorecard';
import golfLeaderboard from './golf/leaderboard/golfLeaderboard';
import historicalDeviceList from './device/historicalDeviceList';
import userProfileBase from './userProfileBase/userProfileBase';
import groupRide from './groupRide/groupRide';
import imagePaths from './imagePaths/imagePaths';
import userSocialProfileImageReducer from './userSocialProfileImage/userSocialProfileImageReducer';
import chinaInterpreterReducer from './chinaInterpreterReducer/chinaInterpreterReducer';
import triathlonTypes from './calendar/eventsReducers';
import respirationReportsData from './respiration/respirationReportsData';
import timingGates from './timingGates/timingGatesReducer';
import trainingGuidance from './trainingGuidance/trainingGuidance';

export default {
    component,
    systemMessage,
    pageMessages,
    registeredDevices,
    publicUserProfile,
    userSocialProfile,
    userPrivacy,
    customUserPrivacy,
    comments,
    conversations,
    dailySummary,
    personalRecords,
    personalRecordCandidates,
    personalRecordTypes,
    personalRecordByActivityId,
    matSupportPage,
    connectionProfileStatus,
    pendingConnections,
    connectionsLeaderboard,
    badges,
    modalState,
    userDailySteps,
    validateDailySummary,
    validateDeviceEpoch,
    validateDeviceEpochSummary,
    validateDeviceHeartRate,
    validateDeviceHeartRateSummary,
    userPersonalInfo,
    userStatistics,
    favoriteActivities,
    calendarPage,
    trainingPlansForDate,
    activityTypes,
    activityHrTimeInZones,
    activityPowerTimeInZones,
    surfaceTypes,
    segmentTypes,
    groups,
    groupPage,
    groupPageLeaderboard,
    groupPageInvite,
    groupPageCourse,
    groupPageReportPhotoDialog,
    activities,
    goals,
    courses,
    comCourses,
    workouts,
    workoutById,
    workoutSteps,
    workoutSchedule,
    workoutsExport,
    workoutsFilter,
    workoutTypes,
    exerciseData,
    upcomingEvents,
    upcomingCalEvents,
    profilePage,
    monthlyReport,
    stepsReports,
    pushesReports,
    activities365Report,
    activityList,
    activityPolyline,
    activityMapDetailsReducer,
    gear,
    commentLikes,
    conversationLikes,
    groupConversations,
    groupConversationLikes,
    userPreference,
    activitySearch,
    selectedDive,
    activitySummary,
    activitySummaryWeekly,
    activitySummaryMonthly,
    activitySummaryYearly,
    segments,
    segmentPage,
    segment,
    systemPreference,
    HERELocation,
    usageIndicators,
    playerGolfStats,
    golfStatsPageState,
    driveGolfStats,
    approachGolfStats,
    chipGolfStats,
    puttGolfStats,
    golfClubs,
    golfClubTypes,
    badgesPage,
    atpPlan,
    atpNextWorkout,
    atpCalendar,
    atpRescheduleDays,
    atpFeed,
    adaptiveTrainingPlanArticle,
    atpContentFulVideoItem,
    atpFeedPartialContent,
    atpActivityFeedback,
    gdprFeature,
    gdprConsentText,
    gdprRevokeConsent,
    gdprGrantConsent,
    gdprDisplayLimitedFeatureAlert,
    atpCoachInfo,
    preference,
    fitnessStats,
    pulseOxAcclimation,
    activitiesForDailySummary,
    activitiesListForTimeframe,
    mergedSummary,
    mergedSummaryCount,
    lastSyncTimestamp,
    dailySleepData,
    autoDetectedEvents,
    dailyStressData,
    dailyMovement,
    dailyHeartRate,
    heartRateZones,
    powerZones,
    moveIQEvents,
    deviceList,
    registeredDeviceList,
    deviceInfo,
    primaryTrainingDevice,
    deviceInfoByPartNumber,
    deviceByHealthDeviceId,
    hydration,
    viewerUserPreferences,
    userSettings,
    userStats,
    userSummaryAverages,
    strava,
    insightsList,
    stepsLifetimeTotals,
    paceProCreate,
    wellnessGoals,
    consolidatedStepsGoal,
    consolidatedPushesGoal,
    dailySteps,
    dailyPushes,
    mfpLinkStatus,
    paceProBand,
    menstrualCycleTrackingSummary,
    menstrualCycle,
    menstrualCycleTrackingCalendar,
    menstrualCycleTrackingReports,
    menstrualCycleTrackingInitialSetup,
    workoutExecutionMetrics,
    userCapable,
    bodyBatteryToday,
    weightList,
    dailyCalories,
    mfp,
    dailySummaryActions,
    dailyPulseOxData,
    dailyRespirationData,
    respirationReportsData,
    dayWeightList,
    weightPage,
    wellnessGoal,
    latestWeight,
    paceProAlgorithmConfig,
    golfCourse,
    golfCourses,
    golfCourseLayout,
    golfCourseStats,
    solarIntensity,
    trainingStatusDaily,
    pregnancyTracking,
    phasedTrainingPlan,
    powerGuidance,
    indoorClimbDifficulty,
    intensityMinutes,
    activityDetails,
    challenge,
    epochDataReload,
    userSummaryMonthly,
    bloodPressure,
    latestBP,
    fitnessAge,
    ftp,
    ftpRange,
    typedSplits,
    timeZones,
    shareableEvent,
    benchmarkExercises,
    exerciseTypes,
    exerciseEquipments,
    muscleMappingModel,
    golfProfile,
    golfScorecardSummary,
    exportReport: exportReportReducer,
    healthSnapshotList,
    healthSnapshotDetails,
    healthSnapshotsForDailySummary,
    powerBenchmarks,
    newsFeedActivities,
    newsFeedComments,
    newsFeedLikes,
    newsFeedConnections,
    notification,
    multiSportActivitySummary,
    floorsData,
    floorsReportData,
    totalCaloriesReports,
    ecgRecordingList,
    ecgRecordingDetails,
    ecgRecordingDailySummary,
    ecgRecordings,
    trainingReadiness,
    eventBasedGoals,
    blockUser,
    hrvStatus,
    mutualConnections,
    stressDataReports,
    hydrationDataReports,
    weatherStationDTO,
    demographicSelections,
    heartRateReport,
    demographicCompare,
    demographicComparePreferences,
    sleepDataReports,
    insightData,
    connections,
    jetLagSetupTrip,
    jetLagTrips,
    jetLagDailyStatus,
    cssReports,
    challengePage,
    systemReducer,
    gears,
    golfClubsFlexTypes,
    bodyBattery,
    inboxPage,
    latestLactateThreshold,
    lactateThresholdRangeHR,
    lactateThresholdRangeSpeed,
    deviceBackups,
    sleepReport,
    dailySleepEpochs,
    emailNotification,
    currentUserInfo,
    thirdPartyApps,
    hillScoreDataReports,
    optionalFeature,
    vo2MaxMetrics,
    enduranceScoreDataReports,
    createChallengePage,
    golfPlayerShots,
    golfHistoricalShots,
    reportsToggledItems,
    golfScorecard,
    trainingPlanIntegration,
    fbtAdaptiveCoachingTrainingPlan,
    socialReducer,
    golfLeaderboard,
    deviceBetaSoftwareInfo,
    dswTrainingPlans,
    historicalDeviceList,
    trainingStatusReport,
    userProfileBase,
    groupRide,
    imagePaths,
    userSocialProfileImageReducer,
    chinaInterpreterReducer,
    triathlonTypes,
    timingGates,
    trainingGuidance
};
